
import { defineComponent, PropType } from "vue";
import MdProgressIndicatorMixin from "./MdProgressIndicatorMixin";

export default defineComponent({
  name: "MdProgressIndicatorLinear",
  mixins: [MdProgressIndicatorMixin],
});
